import { render, staticRenderFns } from "./specEdit.vue?vue&type=template&id=2abf3d9c&scoped=true&"
import script from "./specEdit.vue?vue&type=script&lang=js&"
export * from "./specEdit.vue?vue&type=script&lang=js&"
import style0 from "./specEdit.vue?vue&type=style&index=0&id=2abf3d9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf3d9c",
  null
  
)

export default component.exports